<template>
  <div id="myuser">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a>Sales Pipeline</a>
        </li>
      </ol>
    </div>

    <div class="content login middle" v-loading="loading">
      <div class="cell">
        <div class="container mb50">
          <div class="row mt20">
            <p class="sub-title text-center">MY SALES PIPELINE</p>
            <div class="col-xs-12">
              <div class="row">
                <div class="col-xs-12 text-center">
                  <el-input
                    v-model="search_query"
                    size="big"
                    suffix-icon="el-icon-search"
                    placeholder="Find a lead"
                    clearable
                    class="mt20"
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="col-xs-12 mt30 mb10">
              <a
                href="#"
                @click="add_lead"
                v-if="userType != 'admin' && userType != 'salesvp'"
              >
                <span class="iconfont2 icon-g7 button-icon font36 mr20"></span>
                <span class="font18 black text-middle">ADD A NEW LEAD</span>
              </a>
              <span v-else>
                <span
                  class="iconfont3 icon-IconDashboard-Manageusers1 font36 mr20"
                ></span>
                <span class="font18 black text-middle"
                  >PARTNER COMPANY NAME</span
                >
              </span>

              <el-tooltip
                class="item pull-right mt20"
                effect="dark"
                content="Download XLS"
                placement="top"
                v-if="userType == 'admin' || userType == 'salesvp'"
              >
                <a class="black mr20" @click="downloadXLS()">
                  <span class="iconfont3 icon-download font20"></span>
                </a>
              </el-tooltip>
            </div>
            <div class="col-xs-12 mb20" v-if="leadList">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingOne">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <span
                        class="iconfont3 icon-pipeline_open button-icon mr20"
                      ></span>
                      OPEN
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseOne"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w10">Entry Date</th>
                          <th class="w10">Sales Person</th>
                          <th class="w10">Dealer</th>
                          <th class="w10">Quotation Description</th>
                          <th class="w10">Quote Value (USD)</th>
                          <th class="w10">Project Type</th>
                          <th>Range</th>
                          <th>Collection</th>
                          <th>Probability</th>
                          <th class="w10">Next Action</th>
                          <th class="text-center w10"></th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr v-for="(i, index) in filtered_open" :key="index">
                            <td class="text-right">
                              {{
                                new Date(i.entry_date)
                                  | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                            <td class>{{ i.sales_person }}</td>
                            <td class>{{ i.dealer }}</td>
                            <td class>{{ i.description }}</td>
                            <td class>{{ i.value }}</td>
                            <td class>{{ i.project_type }}</td>
                            <td class>{{ i.range }}</td>
                            <td class>{{ i.collection }}</td>
                            <td class>{{ i.probability }}</td>
                            <td class>{{ i.next_action }}</td>
                            <td class="text-center option h40">
                              <template
                                v-if="
                                  userType != 'admin' && userType != 'salesvp'
                                "
                              >
                                <a class="black" @click="edit_lead(i._id)">
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                                <a class="black" @click="delete_lead(i._id)">
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwo">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseTwo"
                    >
                      <span
                        class="iconfont3 icon-pipeline_closed button-icon mr20"
                      ></span>
                      CONFIRMED/ORDERED/CLOSED
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseTwo"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w10">Entry Date</th>
                          <th class="w10">Sales Person</th>
                          <th class="w10">Dealer</th>
                          <th class="w10">Quotation Description</th>
                          <th class="w10">Quote Value (USD)</th>
                          <th class="w10">Project Type</th>
                          <th>Range</th>
                          <th>Collection</th>
                          <th>Probability</th>
                          <th class="w10">Next Action</th>
                          <th class="text-center w10"></th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr v-for="(i, index) in filtered_won" :key="index">
                            <td class="text-right">
                              {{
                                new Date(i.entry_date)
                                  | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                            <td class>{{ i.sales_person }}</td>
                            <td class>{{ i.dealer }}</td>
                            <td class>{{ i.description }}</td>
                            <td class>{{ i.value }}</td>
                            <td class>{{ i.project_type }}</td>
                            <td class>{{ i.range }}</td>
                            <td class>{{ i.collection }}</td>
                            <td class>{{ i.probability }}</td>
                            <td class>{{ i.next_action }}</td>
                            <td class="text-center option h40">
                              <template
                                v-if="
                                  userType != 'admin' && userType != 'salesvp'
                                "
                              >
                                <a class="black" @click="edit_lead(i._id)">
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                                <a class="black" @click="delete_lead(i._id)">
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingThree">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseThree"
                    >
                      <span
                        class="iconfont3 icon-pipeline_lost button-icon mr20"
                      ></span>
                      LOST
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseThree"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w10">Entry Date</th>
                          <th class="w10">Sales Person</th>
                          <th class="w10">Dealer</th>
                          <th class="w10">Quotation Description</th>
                          <th class="w10">Quote Value (USD)</th>
                          <th class="w10">Project Type</th>
                          <th>Range</th>
                          <th>Collection</th>
                          <th>Probability</th>
                          <th class="w10">Next Action</th>
                          <th class="text-center w10"></th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr v-for="(i, index) in filtered_lost" :key="index">
                            <td class="text-right">
                              {{
                                new Date(i.entry_date)
                                  | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                            <td class>{{ i.sales_person }}</td>
                            <td class>{{ i.dealer }}</td>
                            <td class>{{ i.description }}</td>
                            <td class>{{ i.value }}</td>
                            <td class>{{ i.project_type }}</td>
                            <td class>{{ i.range }}</td>
                            <td class>{{ i.collection }}</td>
                            <td class>{{ i.probability }}</td>
                            <td class>{{ i.next_action }}</td>
                            <td class="text-center option h40">
                              <template
                                v-if="
                                  userType != 'admin' && userType != 'salesvp'
                                "
                              >
                                <a class="black" @click="edit_lead(i._id)">
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                                <a class="black" @click="delete_lead(i._id)">
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="addnew"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog w80" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="resetLead()"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p
              class="font18 text-center mb40"
              style="text-transform: uppercase"
            >
              {{ action }} A NEW LEAD
            </p>
            <el-form
              :model="current_lead"
              ref="leadForm"
              status-icon
              :rules="rules"
              :validate-on-rule-change="false"
              label-position="right"
              label-width="120px"
            >
              <div class="row mt20">
                <div class="col-sm-3">
                  <el-form-item label="Entry Date" prop="entry_date">
                    <el-date-picker
                      format="dd.MM.yyyy"
                      class="w100"
                      v-model="current_lead.entry_date"
                      type="date"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="col-sm-3">
                  <el-form-item label="Lead Source" prop="lead_source">
                    <el-select
                      v-model="current_lead.lead_source"
                      class="w100"
                      allow-create
                      filterable
                    >
                      <el-option value="Black Nova"></el-option>
                      <el-option value="Partner"></el-option>
                      <el-option value="Leader"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="col-sm-3">
                  <el-form-item label="Sales Person" prop="sales_person">
                    <el-select
                      v-model="current_lead.sales_person"
                      class="w100"
                      allow-create
                      filterable
                      :disabled="salesPersonDisabled"
                    >
                      <el-option
                        v-for="sp of salesPersons"
                        v-bind:key="sp._id"
                        :label="sp.first_name + sp.last_name"
                        :value="sp.first_name + sp.last_name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="col-sm-3">
                  <el-form-item label="Region" prop="region">
                    <el-input
                      type="text"
                      v-model="current_lead.region"
                      class="w100"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt20">
                <div class="col-sm-3">
                  <el-form-item label="Status" prop="status">
                    <el-input
                      v-model="current_lead.status"
                      class="w100"
                      disabled
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="col-sm-3">
                  <el-form-item label="Dealer">
                    <el-select
                      v-model="current_lead.dealer"
                      class="w100"
                      allow-create
                      filterable
                      :disabled="dealerDisabled"
                    >
                      <el-option
                        v-for="d of dealers"
                        v-bind:key="d._id"
                        :label="d.first_name + d.last_name"
                        :value="d.first_name + d.last_name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="col-sm-3">
                  <el-form-item label="Contact Person" prop="contact_person">
                    <el-input
                      type="text"
                      v-model="current_lead.contact_person"
                      class="w100"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="col-sm-3"></div>
              </div>

              <div class="row mt20">
                <div class="col-sm-4">
                  <el-form-item
                    label="Project Type"
                    prop="project_type"
                    label-width="200px"
                  >
                    <el-select v-model="current_lead.project_type" class="w100">
                      <el-option value="Residential"></el-option>
                      <el-option value="Hospitality"></el-option>
                      <el-option value="Commercial"></el-option>
                      <el-option value="Marine"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="col-sm-8">
                  <el-form-item label="Description" prop="description">
                    <el-input v-model="current_lead.description"></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt20">
                <div class="col-sm-4">
                  <el-form-item
                    label="Collection"
                    prop="collection"
                    label-width="200px"
                  >
                    <el-select v-model="current_lead.collection" class="w100">
                      <el-option value="Aria"></el-option>
                      <el-option value="Alba"></el-option>
                      <el-option value="Axes"></el-option>
                      <el-option value="Mixed"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="col-sm-8">
                  <el-form-item label="Value (USD)" prop="value">
                    <el-input
                      v-model="current_lead.value"
                      class="w30"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt20">
                <div class="col-sm-4">
                  <el-form-item label="Range" prop="range" label-width="200px">
                    <el-select v-model="current_lead.range" class="w100">
                      <el-option value="KNX"></el-option>
                      <el-option value="RS485"></el-option>
                      <el-option value="Crestron"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="col-sm-8">
                  <el-form-item label="Probability" prop="probability">
                    <el-select v-model="current_lead.probability">
                      <el-option label="0%" value="0"></el-option>
                      <el-option label="25%" value="25"></el-option>
                      <el-option label="50%" value="50"></el-option>
                      <el-option label="75%" value="75"></el-option>
                      <el-option label="90%" value="90"></el-option>
                      <el-option label="100%" value="100"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt20">
                <div class="col-sm-4">
                  <el-form-item
                    label="Expected Closing Date"
                    prop="closing_date"
                    label-width="200px"
                  >
                    <el-date-picker
                      format="dd.MM.yyyy"
                      class="w100"
                      v-model="current_lead.closing_date"
                      type="date"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt20">
                <div class="col-sm-4">
                  <el-form-item
                    label="Expected Delivery Date"
                    label-width="200px"
                  >
                    <el-date-picker
                      format="dd.MM.yyyy"
                      class="w100"
                      v-model="current_lead.delivery_date"
                      type="date"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt20">
                <div class="col-sm-6">
                  <el-form-item label="Remarks" label-width="200px">
                    <el-input
                      class="w100"
                      v-model="current_lead.remarks"
                      maxlength="512"
                      rows="5"
                      show-word-limit
                      type="textarea"
                    >
                    </el-input>
                  </el-form-item>
                </div>
                <div class="col-sm-6">
                  <el-form-item label="Next Action" prop="next_action">
                    <el-input
                      class="w100"
                      v-model="current_lead.next_action"
                      type="text"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="mt50 text-center">
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="el-button mr20"
                  @click="resetLead()"
                >
                  Cancel
                </button>
                <el-button
                  type="button"
                  class="el-button el-button--primary"
                  aria-label="Close"
                  @click="send_lead(current_lead._id)"
                  >OK</el-button
                >
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";
export default {
  name: "salespipeline",
  data() {
    var required = (rule, value, callback) => {
      if (typeof value == "undefined" || value == null || value == "") {
        callback(new Error("Required"));
      } else {
        callback();
      }
    };
    return {
      dealerDisabled: false,
      salesPersonDisabled: false,
      action: "Create",
      loading: false,
      leadList: null,
      search_query: "",
      salesPersons: [],
      dealers: [],
      current_lead: {
        entry_date: new Date(),
        status: "Open",
        lead_source: "",
        sales_person: "",
        region: "",
        dealer: "",
        contact_person: "",
        project_type: "",
        description: "",
        collection: "",
        value: "",
        range: "",
        probability: "50",
        closing_date: "",
        delivery_date: "",
        remarks: "",
        next_action: "",
        created_by: "",
      },
      rules: {
        entry_date: [{ validator: required, trigger: ["change"] }],
        lead_source: [{ validator: required, trigger: ["change"] }],
        sales_person: [{ validator: required, trigger: ["change"] }],
        region: [{ validator: required, trigger: ["change"] }],
        status: [{ validator: required, trigger: ["change"] }],
        contact_person: [{ validator: required, trigger: ["change"] }],
        project_type: [{ validator: required, trigger: ["change"] }],
        description: [{ validator: required, trigger: ["change"] }],
        collection: [{ validator: required, trigger: ["change"] }],
        value: [{ validator: required, trigger: ["change"] }],
        range: [{ validator: required, trigger: ["change"] }],
        probability: [{ validator: required, trigger: ["change"] }],
        closing_date: [{ validator: required, trigger: ["change"] }],
        next_action: [{ validator: required, trigger: ["change"] }],
      },
    };
  },
  methods: {
    resetLead() {
      var sales_person = "";
      var dealer = "";
      if (this.userType == "distributorsmanager") {
        sales_person = this.current_lead.sales_person;
      } else if (this.userType == "dealers") {
        dealer = this.current_lead.dealer;
        sales_person = this.current_lead.sales_person;
      }
      this.current_lead = {
        entry_date: new Date(),
        status: "Open",
        lead_source: "",
        sales_person: sales_person,
        region: "",
        dealer: dealer,
        contact_person: "",
        project_type: "",
        description: "",
        collection: "",
        value: "",
        range: "",
        probability: "50",
        closing_date: "",
        delivery_date: "",
        remarks: "",
        next_action: "",
        created_by: "",
      };
      this.$refs.leadForm.resetFields();
    },
    getData: function () {
      this.loading = true;
      axios
        .get("/lead/" + this.$store.state.user._id)
        .then((response) => {
          if (
            typeof response.data != "undefined" &&
            Array.isArray(response.data)
          ) {
            this.leadList = response.data;
          } else {
            this.leadList = [];
          }
          this.loading = false;
        })
        .catch(function (error) {
          this.loading = false;
          alert(error);
        });
    },
    async downloadXLS() {
      this.loading = true;
      var fileName =
        "BN_" +
        this.$options.filters.dateFormat(new Date(), "DDMMYYYY") +
        "_Pipeline.xlsx";

      try {
        var response = await axios("/lead/xls/" + this.$store.state.user._id, {
          responseType: "blob",
        });
        var blob = response.data;
        this.loading = false;
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } catch (err) {
        this.loading = false;
        window.console.log(err);
      }
    },
    fetchUsers() {
      axios
        .get("/user/" + this.$store.state.user._id)
        .then((response) => {
          if (
            typeof response.data != "undefined" &&
            Array.isArray(response.data)
          ) {
            if (this.userType == "distributorsmanager") {
              this.current_lead.sales_person =
                this.$store.state.user.first_name +
                " " +
                this.$store.state.user.last_name;
              this.salesPersonDisabled = true;
            } else {
              this.salesPersons = response.data.filter(function (item) {
                return item.type.toLowerCase() == "distributorsmanager";
              });
            }
            this.dealers = response.data.filter(function (item) {
              return item.type.toLowerCase() == "dealers";
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    fetchPartner() {
      axios
        .get("/user/single/" + this.$store.state.user.created_by)
        .then((response) => {
          if (
            typeof response.data != "undefined" &&
            response.data
          ) {
            this.current_lead.sales_person =
              response.data.first_name + " " + response.data.last_name;
            this.current_lead.dealer =
              this.$store.state.user.first_name +
              " " +
              this.$store.state.user.last_name;
            this.salesPersonDisabled = true;
            this.dealerDisabled = true;
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    add_lead() {
      this.action = "Create";
      window.$("#addnew").modal("show");
    },
    edit_lead(id) {
      this.action = "Update";
      this.current_lead = Object.assign(
        {},
        this.leadList.find((lead) => lead._id == id)
      );
      window.$("#addnew").modal("show");
    },
    send_lead(id) {
      var action = "put";
      this.$refs.leadForm.validate((valid) => {
        if (valid) {
          if (typeof id == "undefined") {
            this.current_lead.created_by = this.$store.state.user._id;
            id = "";
            action = "post";
          }
          this.loading = true;
          this.current_lead.closing_date = this.$options.filters.dateFormat(
            new Date(this.current_lead.closing_date),
            "DD.MM.YYYY"
          );
          this.current_lead.entry_date = this.$options.filters.dateFormat(
            new Date(this.current_lead.entry_date),
            "DD.MM.YYYY"
          );
          this.current_lead.delivery_date = this.$options.filters.dateFormat(
            new Date(this.current_lead.delivery_date),
            "DD.MM.YYYY"
          );

          axios[action]("/lead/" + id, {
            lead: this.current_lead,
          })
            .then((res) => {
              if (res.data.ok == 1) {
                this.$message({
                  type: "success",
                  message: this.action + "d!",
                });
                this.getData();
                this.resetLead();
              } else {
                this.$message({
                  type: "error",
                  message: this.action + " Failed!",
                });
              }
              window.$("#addnew").modal("hide");
              this.loading = false;
            })
            .catch(function (error) {
              this.loading = false;
              alert(error);
            });
        }
      });
    },
    delete_lead(ID) {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE LEAD",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete lead?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.loading = true;
            axios
              .delete("/lead/" + ID)
              .then((res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  this.getData();
                  done();
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
                this.loading = false;
              })
              .catch(function (error) {
                this.loading = false;
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
  },
  watch: {
    "current_lead.probability": function (newVal) {
      if (newVal == 0) {
        this.current_lead.status = "Lost";
      } else if (newVal == 100) {
        this.current_lead.status = "Won";
      } else {
        this.current_lead.status = "Open";
      }
    },
  },
  mounted() {
    this.getData();
    if (
      this.userType == "distributors" ||
      this.userType == "distributorsmanager"
    ) {
      this.fetchUsers();
    } else if (this.userType == "dealers") {
      this.fetchPartner();
    }
  },
  computed: {
    userType: function () {
      return this.$store.state.user.type;
    },
    filtered_open: function () {
      return this.leadList.filter((lead) => {
        return (
          lead.status == "Open" &&
          lead.sales_person
            .toLowerCase()
            .includes(this.search_query.toLowerCase())
        );
      });
    },
    filtered_won: function () {
      return this.leadList.filter((lead) => {
        return (
          lead.status == "Won" &&
          lead.sales_person
            .toLowerCase()
            .includes(this.search_query.toLowerCase())
        );
      });
    },
    filtered_lost: function () {
      return this.leadList.filter((lead) => {
        return (
          lead.status == "Lost" &&
          lead.sales_person
            .toLowerCase()
            .includes(this.search_query.toLowerCase())
        );
      });
    },
  },
};
</script>

<style>
</style>
